<template>
  <v-container fluid justify-start>

    <!-- Data Table -->
    <v-data-table
      :headers="headers"
      :items="kioskEmails"
      :loading="isLoading"
      :search="search"
      :no-data-text="noDataText"
      item-key="id"
      :loading-text="getExpression('Alert', 'LoadingItems')"
      :footer-props="{
        'items-per-page-text': getExpression('Label', 'RowsPerPage')
      }"
      class="elevation-2"
      >
      <v-progress-linear slot="progress" :color="appColor_Progress" indeterminate></v-progress-linear>

      <template v-slot:top>

        <!-- Header Toolbar -->
        <v-toolbar dense dark flat :color="toolbarColor">
          
          <app-back-button v-bind:color="toolbarColorDark" />

          <v-toolbar-title :class="titleClass">{{ title }}</v-toolbar-title>
          
          <v-spacer />

          <!-- Send Dialog -->
          <v-toolbar-items>
            <v-dialog v-model="editDialog" :max-width="dialogWidth" :persistent="true">
              <loading :active.sync="isSending" :can-cancel="false" loader="dots" :color="appColor_Progress"></loading>
              <template v-slot:activator="{ on }">
                <template v-if="!isAdmin">
                  <v-btn v-if="isSmallDevice" v-on="on" small dark slot="activator" :disabled="isCreateDisabled" :color="toolbarColorDark" class="mb-1 mt-0 mr-0 elevation-0" >{{ getExpression('Label', 'New') }}</v-btn>
                  <v-btn v-else slot="activator" v-on="on" large dark :disabled="isCreateDisabled" :width="createButtonWidth" :color="toolbarColorDark" class="mb-1 mt-0 mr-0 elevation-0">{{ getExpression('Button', 'CreateGeniegram') }}</v-btn>
                </template>
              </template>

              <v-toolbar dense dark flat :color="toolbarColorDark">
                <v-toolbar-title><v-icon class="pr-2">mail</v-icon> {{ getExpression('FormTitle', 'NewGeniegram') }}</v-toolbar-title>
              </v-toolbar>
              <v-card>
                <v-card-text class="pt-3 pl-2 pr-2 pb-0 ma-0">
                  <v-container grid-list-md class="pt-0 pb-0">
                    <form>
                      <v-row no-gutters>

                        <v-alert
                          v-if="showResidentAlert"
                          border="top"
                          colored-border
                          type="info"
                          elevation="2"
                          class="mb-0 pt-2 pb-0 px-1"
                          >
                          <v-row align="center">
                            <v-col cols="12" sm="10">
                              <span class="body-2" v-html="getExpression('Alert', 'GeniegramResidentSelectionText')"></span>
                            </v-col>
                            <v-col cols="12" sm="2">
                              <v-icon color="#333">arrow_downward</v-icon>
                            </v-col>
                          </v-row>
                        </v-alert>

                        <!-- Resident(s) -->
                        <v-col cols="12" sm="12">
                          <resident-selector
                            v-model="residentIds"
                            :options="residents"
                            :label="getExpression('Label', 'AssignedResidents')"
                            v-validate="'required'"
                            :error="errors.first('resident')"
                            data-vv-name="resident"
                            ref="residents"
                          />
                        </v-col>

                        <!-- Message -->
                        <v-col cols="12" sm="12">
                          <v-textarea
                            v-model="editedEmail.message"
                            :label="getExpression('Label', 'Message')"
                            auto-grow
                            v-validate="'required'"
                            :error-messages="errors.collect('message')"
                            data-vv-name="message"
                            ref="emailmessage"
                            class="mb-2"
                            hide-details="auto"
                            >
                          </v-textarea>
                        </v-col>

                        <!-- Media Properties -->
                        <template v-if="blobProperties.length > 0">
                          <v-card-text class="px-0 mt-4">
                            <!-- Data Iterator -->
                            <v-data-iterator
                              :items="blobProperties"
                              :items-per-page.sync="itemsPerPage"
                              :page="page"
                              hide-default-footer
                              >
                              <template v-slot:default="props">
                                <div v-for="item in props.items" :key="item.blobName">
                                  <media-properties-form
                                    v-bind:blob="item"
                                    v-bind:showRemoveButton="true"
                                    v-on:remove="removeBlob"
                                  />
                                </div>
                              </template>

                              <!-- Footer -->
                              <template v-slot:footer v-if="numberOfPages > 1">
                                <v-row class="mr-2 pt-2" justify="end">
                                  <span class="mr-4 grey--text subheading">
                                    File {{ page }} of {{ numberOfPages }}
                                  </span>
                                  <v-btn
                                    fab
                                    small
                                    dark
                                    :color="toolbarColorDark"
                                    class="mr-1"
                                    @click="formerPage"
                                    >
                                    <v-icon>keyboard_arrow_left</v-icon>
                                  </v-btn>
                                  <v-btn
                                    fab
                                    small
                                    dark
                                    :color="toolbarColorDark"
                                    class="ml-1"
                                    @click="nextPage"
                                    >
                                    <v-icon>keyboard_arrow_right</v-icon>
                                  </v-btn>
                                </v-row>
                              </template>

                            </v-data-iterator>
                          </v-card-text>
                        </template>
                      </v-row>
                    </form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-btn tile @click="contentTypeSelectorDialog = true" class="ml-3 pr-3">
                    <v-icon left>attach_file</v-icon>
                    {{ getExpression('Button', 'AddMedia') }}
                  </v-btn>

                  <v-spacer />
                  
                  <v-btn @click="cancelDialog" :loading="isSending" class="rounded-0" large>{{ getExpression('Button', 'Cancel') }}</v-btn>
                  <v-btn :color="toolbarColorDark" dark @click="send" :loading="isSending" class="rounded-0 ml-4" large>{{ getExpression('Button', 'Send') }}</v-btn>

                </v-card-actions>
              </v-card>
            </v-dialog>

            <input
              v-show="false"
              type="file"
              ref="audio"
              multiple
              accept="audio/mp3"
              @change="fileChanged('audio')"
            />
            
            <input
              v-show="false"
              type="file"
              ref="image"
              multiple
              accept="image/*"
              @change="fileChanged('image')"
            />
    
            <input
              v-show="false"
              type="file"
              ref="video"
              multiple
              accept="video/mp4"
              @change="fileChanged('video')"
            />
          </v-toolbar-items>
        </v-toolbar>

        <!-- Filters -->
        <v-row no-gutters class="pt-2 mx-3 mb-2">

          <!-- Search Text -->
          <v-col cols="12" sm="12">
            <v-text-field
              v-model="search"
              append-icon="search"
              :label="getExpression('Label', 'Search')"
              :disabled="isLoading"
              clearable
              >
            </v-text-field>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item="{ item }">
        <tr>
          <td>
            <v-btn
              @click="showDetail(item)"
              outlined
              icon
              class="mr-2"
              ><v-icon>details</v-icon>
            </v-btn>
          </td>
          <td class="text-left">
            <app-date :date="item.createDate" />
          </td>
          <td class="text-left">{{ getSender(item) }}</td>
          <td class="truncate">{{ item.message}}</td>
          <td class="text-left">{{ item.blobs.length }}</td>
        </tr>
      </template>

    </v-data-table>

    <!-- Kiosk Email Detail -->
    <v-dialog
      v-model="detailDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <kiosk-email-detail
        v-bind:kioskEmail="editedEmail"
        v-bind:toolbarColor="toolbarColor"
        v-bind:toolbarColorDark="toolbarColorDark"
        v-on:done="detailClose"
      />
    </v-dialog>

    <!-- Content Type Selector -->
    <v-dialog v-model="contentTypeSelectorDialog" :max-width="contentTypeSelectorWidth" persistent>
      <content-type-selector
        v-on:select="closeChooseContentType"
        v-on:cancel="contentTypeSelectorDialog = false"
        v-bind:label="contentTypeSelectorLabel"
        v-bind:disabledTypes="disabledContentTypes"
        v-bind:toolbarColor="toolbarColor"
        v-bind:toolbarColorDark="toolbarColorDark"
      />
    </v-dialog>

    <!-- Media Picker -->
    <v-dialog v-model="mediaDialog" :persistent="true" width="900px">
      <media-selector
        v-model="mediaSelectorParams"
        :defaultContainer="defaultContainer"
        :containers="containers"
        :toolbarColor="toolbarColor"
        :toolbarColorDark="toolbarColorDark"
        v-on:cancel="mediaDialog = false"
        v-on:ok="addSelectedMedia"
        style="overflow-y: none;"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import appService from '@/app.service'
import KioskEmailDetail from '@/components/KioskEmailDetail'
import AppDate from '@/components/App/AppDate'
import AppBackButton from '@/components/App/AppBackButton'
import ContentTypeSelector from '@/components/ContentTypeSelector'
import MediaPropertiesForm from '@/components/MediaPropertiesForm'
import MediaSelector from '@/components/MediaSelector'
import ResidentSelector from '@/components/ResidentSelector'
import { mapGetters } from 'vuex'
import { AppColor, LanguageId, KioskFolder, ImageUri, DestinationId } from '@/config.js'

export default {
  name: 'KioskEmailManager',
  components: {
    KioskEmailDetail,
    AppDate,
    AppBackButton,
    ContentTypeSelector,
    MediaPropertiesForm,
    MediaSelector,
    ResidentSelector
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {

      // colors
      appColor_Progress: AppColor.Progress,
      appColor_Resident: AppColor.Resident,
      appColor_Genie: AppColor.KioskTypeGenieLight,
      appColor_GenieDark: AppColor.KioskTypeGenie,

      // kiosk folders
      kioskFolder_Email: KioskFolder.Email,
      
      // uri
      imageUri_AudioVideoPlaceholder: ImageUri.AudioVideoPlaceholder,
      
      // destination ids
      destinationId_MediaLibrary: DestinationId.MediaLibrary,

      page: 1,
      itemsPerPage: 1,
      itemsPerPageArray: [1, 4, 12],

      search: '',
      isLoading: false,
      isSending: false,
      contentTypeSelectorDialog: false,
      editDialog: false,
      detailDialog: false,
      mediaDialog: false,
      residentDialog: false,
      kioskEmails: [],
      isValidResidents: false,
      blobProperties: [],
      mediaFiles: [],
      residents: [],
      uploadContentType: null,

      // resident selector
      residentIds: [],

      // media selector
      mediaSelectorParams: {
        controlId: null,
        selectionType: ''
      },

      editedIndex: -1,
      editedEmail: {
        id: -1,
        subject: null,
        message: null,
        sender: null,
        blobs: [],
        users: [],
        createDate: null
      },
      defaultEmail: {
        id: -1,
        subject: null,
        message: null,
        sender: null,
        blobs: [],
        users: [],
        createDate: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'profile',
      'activeKiosk',
      'isAdmin',
      'isKioskManager',
      'currentRoute',
      'previousRoute',
      'locale']),
    title () {
      return this.activeKioskName
    },
    noDataText () {
      if (this.isLoading) return this.getExpression('Alert', 'OneMoment')

      return this.kioskEmails.length === 0
        ? this.getExpression('Alert', 'NoKioskEmails')
        : ''
    },
    activeKioskName () {
      if (this.isNullOrUndefined(this.activeKiosk)) return null
      return this.activeKiosk.serialNumber
    },
    headers () {
      return [{
          text: this.getExpression('Label', 'Detail'),
          value: 'id',
          align: 'left',
          width: '10%'
        },
        {
          text: this.getExpression('Label', 'Sent'),
          value: 'createDate',
          align: 'left',
          width: '20%'
        },
        {
          text: this.getExpression('Label', 'Sender'),
          value: 'sender',
          align: 'left',
          width: '20%'
        },
        {
          text: this.getExpression('Label', 'Message'),
          value: 'message',
          align: 'left',
          maxWidth: '45%'
        },
        {
          text: this.getExpression('Label', 'Attachments'),
          value: 'blobs',
          align: 'left',
          width: '15%'
        }
      ]
    },
    dictionary () {
      return {
        custom: {
          message: {
            required: () => this.getExpression('Validation', 'EmailMessageRequired')
          },
          resident: {
            required: () => this.getExpression('Validation', 'ResidentRequired')
          }
        }
      }
    },
    numberOfPages () {
      if (this.blobProperties === null) return 0
      return Math.ceil(this.blobProperties.length / this.itemsPerPage)
    },
    defaultContainer () {
      if (this.activeKiosk === null) return null
      return this.activeKiosk.container
    },
    containers () {
      return [{ containerName: this.defaultContainer, displayName: this.activeKioskName }]
    },
    uploadMediaType () {
      if (this.uploadContentType === null) return null
      return this.uploadContentType.substring(0, this.uploadContentType.lastIndexOf('/'))
    },
    isCreateDisabled () {
      if (this.isLoading || this.isSending) return true
      return !this.isValidResidents
    },
    showResidentAlert () {
      return (this.residentIds ?? []).length === 0
    },
    toolbarColor () {
      return this.appColor_Genie
    },
    toolbarColorDark () {
      return this.appColor_GenieDark
    },
    isFromKioskDashboard () {
      return this.previousRoute.indexOf('KioskDashboard') >= 0
        || (this.previousRoute.indexOf('Home') >= 0 && this.isKioskManager)
    },
    contentTypeSelectorLabel () {
      var label = this.getExpression('Label', 'Content')
      return this.profile.languageId === LanguageId.English
        ? label
        : label.toLowerCase()
    },
    titleClass () {
      return this.isSmallDevice
        ? 'body-2'
        : ''
    },
    contentTypeSelectorWidth () {
      return this.profile.languageId === LanguageId.English
        ? '220px'
        : '290px'
    },
    createButtonWidth () {
      return this.profile.languageId === LanguageId.English
        ? '180px'
        : '190px'
    },
    disabledContentTypes () {
      if (this.uploadContentType === null) return null
      const mediaType = this.uploadMediaType

      if (mediaType === 'image' || mediaType === 'audio') {
        return ['video']
      }
      if (mediaType === 'video') {
        return ['image', 'audio']
      }
      return null
    },
    dialogWidth () {
      return this.profile.languageId === LanguageId.English
        ? '400px'
        : '480px'
    }
  },
  methods: {
    loadData () {
      if (!this.isValidSession) return
      const self = this
      self.isLoading = true
      
      const kioskId = self.activeKiosk.id
      appService.getKioskEmails(kioskId).then(data => {
        if (data.errorSeverity > 0) {
          self.handleError(data)
        } else {
          self.kioskEmails = data.kioskEmails
          self.residents = data.selectorResidents ?? []
          self.isValidResidents = self.residents.filter(r => r.isSelectable).length > 0
        }
        self.isLoading = false
      }).catch(() => { this.handleCriticalError() })
    },

    getSender (item) {
      return item.sender.id === this.profile.id
        ? `${item.sender.nickname} (You)`
        : item.sender.nickname
    },

    showDetail (item) {
      this.editedIndex = this.kioskEmails.indexOf(item)
      this.editedEmail = Object.assign({}, item)
      this.detailDialog = true
    },

    closeChooseContentType (type) {
      this.contentTypeSelectorDialog = false

      switch (type) {
        case 'audio':
          this.$refs.audio.click()
          break
        case 'image':
          this.$refs.image.click()
          break
        case 'video':
          this.$refs.video.click()
          break
        case 'library':
          this.pickMedia()
          break
      }
    },

    fileChanged (ref) {
      const files = this.$refs[ref].files
      const maxFiles = files.length
      var ext = null

      for (var idx = 0; idx < maxFiles; idx++) {
        const file = files[idx]

        var previewUrl = ''
        this.uploadContentType = file.type
        const mediaType = this.uploadMediaType
        ext = file.name.split('.').pop()

        //-- image rules
        if (ref === 'image' && mediaType !== 'video' && mediaType !== 'audio') {
          
          if (ext === 'webp') {
            continue
          }

          previewUrl = URL.createObjectURL(file)

          //-- video rules
        } else if (
          ref === 'video' && mediaType === 'video' &&
          ['video/mp4'].includes(file.type)
        ) {
          previewUrl = this.imageUri_AudioVideoPlaceholder

          //-- audio rules
        } else if (
          ref === 'audio' && mediaType === 'audio' &&
          ['audio/mp3', 'audio/mp4', 'audio/mpeg'].includes(file.type)
        ) {
          previewUrl = this.imageUri_AudioVideoPlaceholder
        } else {
          continue
        }

        this.mediaFiles.push(file)
        this.blobProperties.unshift({
          blobName: file.name,
          contentType: file.type,
          size: file.size,
          previewUrl: previewUrl,
          title: this.getDefaultTitle(file.name),
          description: null,
          kioskFolder: this.kioskFolder_Email
        })
      }

      if (this.blobProperties.length > 0) {
        this.$refs[ref].value = null
      } else {
        var text = ''
        const languagedContentType = this.getLanguagedContentType(ref)

        if (ref === 'image') {
          text = this.getExpression('Alert', 'SelectValidFiles').replace('{0}', languagedContentType)
        } else if (ref === 'video') {
          text = this.getExpression('Alert', 'FileTypeNotAccepted').replace('{0}', ext)
        } else if (ref === 'audio') {
          text = this.getExpression('Alert', 'OnlyMp3Supported')
        }
        this.$error.show({
          title: this.getExpression('FormTitle', 'InvalidMedia'),
          severity: 0,
          text: text
        })
      }
    },

    send () {
      const self = this

      self.$validator.resume()
      self.$validator.validateAll().then(valid => {

        if (valid) {
          const files = self.mediaFiles
          const fileCount = files.length
          let formData = new FormData()

          if (self.blobProperties.length > 0) {
            const libraryMediaItemIds = self.blobProperties
              .filter(p => p.isLibraryItem)
              .map(p => { return p.mediaItemId }).join(',')

            files.forEach(file => {
              formData.append('file', file)
            })

            const metadata = self.blobProperties.map(obj => {
              return {
                blobName: obj.blobName,
                title: obj.title,
                description: obj.description,
                kioskFolder: self.kioskFolder_Email,
                destination: self.destinationId_MediaLibrary
              }
            })

            formData.append('metadata', JSON.stringify(metadata))
            formData.append('containerName', self.activeKiosk.container)
            formData.append('deviceInfo', 'Admin Site')
            formData.append('mediaItemId', libraryMediaItemIds)


          // emails with no media will need a kioskId since containerName won't be provided  
          } else {
            formData.append('kioskId', self.activeKiosk.id)
          }
          
          if (self.residentIds.length > 0) {
            formData.append('residentId', self.residentIds.join(','))
          }
          
          formData.append('message', self.editedEmail.message)
          formData.append('userId', self.profile.id)

          const mediaType = self.getMediaType(self.uploadContentType)

          // default route (message with no media)
          var uploadRoute = ''

          if (mediaType === 'audio') {
            uploadRoute = '/audio'
          } else if (mediaType === 'image') {
            uploadRoute = '/images'
          } else if (mediaType === 'video')  {
            uploadRoute = '/videos'
          }
          
          self.$upload.execute({
            formData: formData,
            url: `kioskemails/send${uploadRoute}`,
            fileCount: fileCount,
            progressExpression: 'SendingEmail',
            onComplete: (data) => {
              if (data.errorSeverity > 0) {
                self.handleError(data)
              } else {
                self.kioskEmails.unshift(data.kioskEmail)
              }
              self.closeDialog()
            }
          })
        }
      })
    },
    
    pickMedia () {
      const self = this
      self.mediaDialog = true
      setTimeout(() => {
        self.mediaSelectorParams = {
          controlId: self.activeKiosk.id,
          selectionType: 'kiosk-email'
        }
      }, 200)
    },

    addSelectedMedia ({ selectedMedia }) {
      const self = this
      
      selectedMedia.forEach(selected => {
        selected.isLibraryItem = true
        var item = self.getPropertiesModel(selected)
        self.blobProperties.unshift(item)
      })
      this.mediaDialog = false
    },

    removeBlob (blobName) {
      const idx1 = this.blobProperties.findIndex(p => p.blobName === blobName)
      if (idx1 >= 0) this.blobProperties.splice(idx1, 1)

      const idx2 = this.mediaFiles.findIndex(f => f.name === blobName)
      if (idx2 >= 0) this.mediaFiles.splice(idx2, 1)

      if (this.mediaFiles.length === 0) {
        this.uploadContentType = null
      }
    },

    getPropertiesModel (m) {
      return {
        mediaItemId: m.mediaItemId,
        blobName: m.blobName,
        title: m.title,
        description: m.description,
        kioskFolder: m.kioskFolder,
        contentType: m.contentType,
        size: m.size,
        previewUrl: m.thumbnail,
        isLibraryItem: m.isLibraryItem
      }
    },

    closeDialog () {
      this.editDialog = false
      this.reset()
    },

    cancelDialog () {
      this.closeDialog()
    },

    detailClose () {
      this.detailDialog = false
      this.reset()
    },

    nextPage () {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },

    formerPage () {
      if (this.page - 1 >= 1) this.page -= 1
    },

    setFocus () {
      const self = this
      setTimeout(() => {
        if (!this.isNullOrUndefined(self.$refs.emailmessage)) {
          self.$refs.emailmessage.focus()
        }
      }, 500)
    },

    reset () {
      this.blobProperties = []
      this.mediaFiles = []
      this.residentIds = []
      this.editedEmail = Object.assign({}, this.defaultEmail)
      this.uploadContentType = null

      this.$validator.reset()
      this.$validator.pause()
    },

    handleError (result) {
      this.$error.show({
        title: result.errorSeverity === 0
                      ? 'Validation Failed'
                      : 'Internal Error',
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    }
  },
  created() {
    this.loadData()
  },
  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },
  watch: {
    editDialog(val) {
      if (val) {
        const self = this
        setTimeout(() => {
         self.$refs.residents.focus()
        }, 300)
      }
    },
    isValidSession (val) {
      if (val === null) return
      this.loadData()
    }
  }
}
</script>

<style>
.truncate {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>